module.exports = __webpack_public_path__ + "img/six-11.6337d13d.png";